import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ApiFundraiserRef } from '@fmnts/api/shared';
import { ApiConfigService, ApiRequestHelper } from '@fmnts/api/util';
import { EMPTY, Observable, expand, reduce } from 'rxjs';
import { IApiFundraiserRefPage } from '../api-model/fundraiser-performance.api';

@Injectable({
  providedIn: 'root',
})
export class FundraiserPerformanceApi {
  private static readonly fundraiserRefsUrl = '/api/v1/fundraisers/refs';

  readonly #http = inject(HttpClient);
  readonly #configService = inject(ApiConfigService);
  readonly #apiHelper = inject(ApiRequestHelper);

  /**
   * Fundraisers the caller can select. `is_active` is never sent, so inactive
   * fundraisers stay in the list. Pages are followed until `next` is empty.
   */
  public listFundraiserRefs(query?: {
    team_id?: number | string | null;
  }): Observable<ApiFundraiserRef[]> {
    let page = 1;

    return this.#listFundraiserRefPage(query, page).pipe(
      expand((response) => {
        if (typeof response.next !== 'string') {
          return EMPTY;
        }
        page += 1;
        return this.#listFundraiserRefPage(query, page);
      }),
      reduce(
        (acc, response) => acc.concat(response.results),
        [] as ApiFundraiserRef[],
      ),
    );
  }

  #listFundraiserRefPage(
    query: { team_id?: number | string | null } | undefined,
    page: number,
  ): Observable<IApiFundraiserRefPage> {
    const url = this.#configService.buildApiUrl([
      FundraiserPerformanceApi.fundraiserRefsUrl,
    ]);
    let params = new HttpParams().set('page', page);
    if (query?.team_id != null) {
      params = params.set('team_id', String(query.team_id));
    }
    const headers = this.#apiHelper.makeDefaultHeaders({});

    return this.#http.get<IApiFundraiserRefPage>(url, { headers, params });
  }
}
